import * as React from 'react'

import { Swagger } from '../../components/Swagger'
import ApiKeysManager from '../../components/ApiKeysManager'

import * as style from './style.module.css'

export interface ApisProps {
  match: any
  classes: any
}

export class SwaggerUI extends React.Component<ApisProps, {}> {
  render() {
    return (
      <div>
        <span className={style.ApiKeyManager}>
          <ApiKeysManager apiId={this.props.match.params.id} />
        </span>
        <Swagger apiId={this.props.match.params.id}/>
      </div>
    )
  }
}
